<template>
  <v-row align="center">
    <v-col cols="12" sm="12">
      <v-card>
        <VueTabulator ref="tabulator" v-model="eventsItems" :options="tabulatorOptions" />
      </v-card>
    </v-col>

    <v-dialog max-width="300px"  v-model="dialog">
        <v-card height="auto" width="300" style="padding: 2%" class="text-input-date">
            <div v-if="picker=='eventDate'">
              <v-date-picker
                v-model="eventDate"
                @change="saveDate"
                :header-date-format="$datePicker.formatDateHeader"
                :title-date-format="$datePicker.formatTitleDate"
                :weekday-format="$datePicker.formatWeekday"
                :month-format="$datePicker.formatMonth"
              ></v-date-picker>
            </div>
            <div v-if="picker=='eventEndDate'">
              <v-date-picker
                v-model="eventEndDate"
                @change="saveDate"
                :header-date-format="$datePicker.formatDateHeader"
                :title-date-format="$datePicker.formatTitleDate"
                :weekday-format="$datePicker.formatWeekday"
                :month-format="$datePicker.formatMonth"
              ></v-date-picker>
            </div>
            <div v-if="picker!='eventEndDate' || picker!='eventDate'">
              <v-datetime-picker 
                :datetime="eventDateC"
                :color="navigationBGColor"
                :header-color="navigationBGColor" 
                :time-picker-props="timeProps" 
                date-format="yyyy-MM-dd"
                time-format="HH:mm:ss" 
                @input="saveDate"
                :datePickerProps="{
                  locale: currentLocale,
                  'header-date-format': $datePicker.formatDateHeader,
                  'title-date-format': $datePicker.formatTitleDate,
                  'weekday-format': $datePicker.formatWeekday,
                  'month-format': $datePicker.formatMonth
                }"
              >
                <template slot="actions" slot-scope="{ parent }">
                  <v-btn color="error" @click.native="dialog= false">{{ $t('common.cancel') }}</v-btn>
                  <v-btn color="success" @click="parent.okHandler">{{ $t('common.done') }}</v-btn>
                </template>
              </v-datetime-picker>
            </div>
        </v-card>
    </v-dialog>
    <SGSNotificationConfirm 
        v-if="dialogNotification" :notificationMessage="$t('dashboard.menu.eventDetails.delete_alert')" 
        small @agree="deleteItem" @cancel="dialogNotification = false" type="warning" :acept="$t('common.form.delete')" :reject="$t('common.form.cancel')"
    />
    <div style="height: 150px;"></div>
  </v-row>
</template>

<script>

import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import { mapGetters } from 'vuex';

export default {
  mixins: [apiCalls],
  components: {
    SGSNotificationConfirm
  },
  computed: {
    ...mapGetters({
      currentLocale: 'currentLocale'
    }),
    tabulatorOptions() {
      return {
        placeholder: this.$t("dashboard.menu.no_events_yet"), //display message to user on empty table
        downloadRowRange: "all",
        printAsHtml: true,
        layout: "fitDataStretch", //fit colu"mns to width of table
        responsiveLayout: false, //hide columns that dont fit on the table
        tooltips: true, //show tool tips on cells
        addRowPos: "top", //when adding a new row, add it to the top of the table
        history: true, //allow undo and redo actions on the table
        movableColumns: false, //allow column order to be changed
        resizableColumns: false,
        columns: [
          {
            title: this.$t("dashboard.menu.eventDetails.race_id"),
            field: "id",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            cellClick: function (e, cell) {
                  const data = cell.getData();
                  this.$router.push({ name: 'eventDetails', params: {id: data.id}});
                }.bind(this),
          },
          {
            title: this.$t("dashboard.menu.eventDetails.eventName"),
            field: "name",
            sorter: "string",
            width: 380,
            formatter: "textarea",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"input",
            cellEdited: function (cell) {
                  this.editEvent("eventName",cell)
            }.bind(this),
          },
          {
            title: this.$t("dashboard.menu.eventDetails.registration-open"),
            field: "registrationOpen",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            cellClick: function (e, cell) {
              this.dialog = true
              this.picker = "eventDateOpen"
              this.dataCell = cell.getData();
              this.eventDateC = cell.getData().registrationOpen;
              
            }.bind(this),
          },
          {
            title: this.$t("dashboard.menu.eventDetails.registration-close"),
            field: "registrationClose",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            cellClick: function (e, cell) {
              this.dialog = true
              this.picker = "eventDateClose"
              this.dataCell = cell.getData();
              this.eventDateC = cell.getData().registrationClose;
              
            }.bind(this),
          },
          {
            title: this.$t("dashboard.menu.eventDetails.eventDate"),
            field: "eventDate",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            cellClick: function (e, cell) {
              this.dialog = true
              this.picker = "eventDate"
              this.dataCell = cell.getData();
              this.eventDate = cell.getData().eventDate
              
            }.bind(this),
          },
          {
            title: this.$t("dashboard.menu.eventDetails.eventEndDate"),
            field: "eventEndDate",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            cellClick: function (e, cell) {
              this.dialog = true
              this.picker = "eventEndDate"
              this.dataCell = cell.getData();
              this.eventEndDate = cell.getData().eventEndDate
              
            }.bind(this),
          },
          {
            title: this.$t("dashboard.menu.eventDetails.displayFlag"),
            field: "displayFlag",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"select",
            formatter: (cell) => {
              const value = cell.getValue();
              return value === 1 || value === "1" || value === true || value === "Yes" ? 
                this.$t("common.form.yes") : 
                this.$t("common.form.no");
            },
            editorParams: {
              values: {
                0: this.$t("common.form.no"),
                1: this.$t("common.form.yes")
              }
            },
            cellEdited: function (cell) {
                  this.editEvent("displayFlag",cell)
            }.bind(this),
            
          },
          {
            title: this.$t(
              "dashboard.menu.eventDetails.displayRegistrationFlag"
            ),
            field: "regOpt",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"select",
            formatter: (cell) => {
              const value = cell.getValue();
              return value === 1 || value === "1" || value === true || value === "Yes" ? 
                this.$t("common.form.yes") : 
                this.$t("common.form.no");
            },
            editorParams: {
              values: {
                0: this.$t("common.form.no"),
                1: this.$t("common.form.yes")
              }
            },
            cellEdited: function (cell) {
                  this.editEvent("regOpt",cell)
            }.bind(this),
          },
          {
            title: this.$t("dashboard.menu.action"),
            hozAlign: "center",
            width: 60,
            headerHozAlign: "center",
            columns: [
            
            {
                width: 20,
                hozAlign: "center",
                headerSort: false,
                formatter: function (e) {
                  const data = e.getData();
                  if(data.regOpt == 'No')
                    return "";
                  else
                    return "<i class='fa fa-cog'></i>";
                }.bind(this),
                cellClick: function (e, cell) {
                  const data = cell.getData();
                  if(data.regOpt == 'Yes')
                    this.$router.push({ name: 'RegistrationSetup', params: {id:  data.id}});
                }.bind(this),
              },
              {
                width: 20,
                hozAlign: "center",
                headerSort: false,
                formatter: function () {
                  return "<i class='far fa-pencil-alt' ></i>";
                }.bind(this),
                cellClick: function (e, cell) {
                  const data = cell.getData();
                  this.$router.push({ name: 'eventDetails', params: {id: data.id}});
                }.bind(this),
              },
              {
                title: "",
                field: "delete",
                width: 20,
                hozAlign: "center",
                headerSort: false,
                formatter: function () {
                  return "<i class='fa fa-trash'></i>";
                }.bind(this),
                cellClick: function (e, cell) {
                  const data = cell.getData();
                  this.confirmDelete(data);
                }.bind(this),
              },
            ]
           
          },
          {
             title: "",
             headerSort: false,
          }
        ],
        dataLoaded: function() {
          if (this.getRows().length > 10) {
            this.setHeight(450);
          }
        }
      };
    }
  },
  data() {
    return {
      eventsItems: [],
      dialogNotification: false,
      eventDateC:'',
      eventDate:'',
      eventEndDate:'',
      dialog: false,
      bam: false,
      dataCell:'',
      picker:'',
      navigationBGColor: "#FFF",
       timeProps: {
         useSeconds: true,
        format:"24hr"
      }
    };
  },
  methods: {
    async eventsItems_() {
      const response = await this.api(
        "get",
        "/api/v1/users/current/getUserEventList/deletedE"
      );

      this.eventsItems = response.message.map((el) => {
        return {
          ...el, 
          name: this.$escapeHtml.decode(el.name)
        };
      });
    },
    async editEvent(input,cell){
      let data = {};

      if (input == "eventName") {
        data.eventName = cell.getData().name;
      } 
      if (input == "displayFlag") {
        if(cell.getData().displayFlag=="No" || cell.getData().displayFlag==0 || cell.getData().displayFlag==false)
          data.displayFlag = 0;
        else
          data.displayFlag = 1;
      }
      if (input == "regOpt") {
        if(cell.getData().regOpt=="No" || cell.getData().regOpt==0 || cell.getData().regOpt==false)
          data.regOpt = 0;
        else
          data.regOpt = 1;
      }

      await this.postApi(
        "/api/v1/promoter/eventDetails/updateEvent/" +
          cell.getData().id,
        data
      );
    },
    close() {
      this.dialogNotification = false;
    },
    confirmDelete(item) {
      this.dialogNotification = true
      this.item = item
    },
    async deleteItem() {
      
      const response = await this.deleteApi(
        "/api/v1/promoter/eventDetails/" +this.item.id,
      );
      if (response != undefined) {
        this.eventsItems_()
        this.close();
      }
    },
    async saveDate(date) {
      let data = {};

      if(this.picker=="eventDate")
        data.eventDate = date;
      if(this.picker=="eventEndDate")
        data.eventEndDate = date;
      if(this.picker=="eventDateClose")
        data.registrationClose = this.getDate(date);
      if(this.picker=="eventDateOpen")
        data.registrationOpen = this.getDate(date);

      await this.postApi(
        "/api/v1/promoter/eventDetails/updateEvent/" +
          this.dataCell.id,
        data
      );

      this.eventsItems_()
      this.dialog = false;
      
    },
    getDate(datetime) {
      let fullDate = new Date(datetime);
      let date = fullDate.toLocaleDateString().split("/");
      let minutes = fullDate.toLocaleTimeString().slice(0, 7).split(":");

      let [month, day, year] = date;
      let [hour, minute, second] = minutes;

      if (month < 10) month = "0" + month;

      if (day < 10) day = "0" + day;

      if (hour < 10) hour = "0" + hour;

      let newDate = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;

      return newDate;
    },
  },
  created() {
    this.eventsItems_();
  }
};
</script>
<style>
.tabulator-placeholder {
  width: 0px;
  overflow-y: hidden;
}
</style>
